import React, { useState, useEffect, useRef } from 'react';
import './sec2.css';
import BookingHero from '../common/headsec';
import strip from '../../asserts/strip.png';
import { supabase } from '../../supabaseClient';

const Sec2 = () => {
    const lang = localStorage.getItem('language') || 'en';
    const [bookingData, setBookingData] = useState(null);
    const [benefits, setBenefits] = useState([]);
    const [categories, setCategories] = useState([]);
    const [events, setEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [selectedEventPrice, setSelectedEventPrice] = useState(0);
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const fullNameRef = useRef();
    const emailRef = useRef();
    const catRef = useRef();
    const eventRef = useRef();
    const ticketRef = useRef();

    useEffect(() => {
        const getData = async () => {
            try {
                const { data: booking } = await supabase.from('booking').select('*').limit(1);
                const { data: ben } = await supabase.from('booking_benefits').select('*');
                const { data: cats } = await supabase.from('categories').select('*');
                const { data: evs } = await supabase.from('events').select('*');

                if (booking && booking.length > 0) setBookingData(booking[0]);
                if (ben) setBenefits(ben);
                if (cats) setCategories(cats);
                if (evs) setEvents(evs);
            } catch (err) {
                console.error(err);
            }
        };

        getData();
    }, []);

    const handleCategoryChange = async (e) => {
        const catId = e.target.value;

        if (!catId) {
            setFilteredEvents([]);
            return;
        }

        const { data: eventCats } = await supabase
            .from('event_categories')
            .select('event_id')
            .eq('category_id', catId);

        if (eventCats) {
            const eventIds = eventCats.map(ec => ec.event_id);
            const filtered = events.filter(ev => eventIds.includes(ev.id));
            setFilteredEvents(filtered);
        }
    };

    const handleEventChange = (e) => {
        const val = Number(e.target.value);
        const found = events.find(ev => ev.id === val);
        if (found) setSelectedEventPrice(found.price);
    };

    const handleBookNow = async () => {
        setSuccessMsg('');
        setErrorMsg('');

        const fullName = fullNameRef.current.value;
        const email = emailRef.current.value;
        const selectedCatId = catRef.current.value;
        const selectedEventId = eventRef.current.value;
        const ticketCount = ticketRef.current.value;

        if (!fullName || !email || !selectedCatId || !selectedEventId || !ticketCount) {
            setErrorMsg(lang === 'ar' ? '* جميع الحقول مطلوبة' : '* All fields are required');
            return;
        }

        let userId = null;

        const { data: existingUser } = await supabase
            .from('users')
            .select('id')
            .eq('email', email)
            .maybeSingle();

        if (existingUser) {
            userId = existingUser.id;
        } else {
            const { data: newUser } = await supabase
                .from('users')
                .insert({ full_name: fullName, email: email, status: 'Active', role: 'User' })
                .select('id')
                .single();

            if (newUser) userId = newUser.id;
        }

        const bookingId = 'BK-' + Math.floor(1000 + Math.random() * 9000);
        const totalPrice = selectedEventPrice * Number(ticketCount);
        const today = new Date().toISOString().split('T')[0];

        const { error } = await supabase.from('bookings').insert({
            booking_id: bookingId,
            user_id: userId,
            event_id: Number(selectedEventId),
            ticket_count: Number(ticketCount),
            total_price: totalPrice,
            status: 'Pending',
            booking_date: today,
            email: email,
            cat_id: Number(selectedCatId),
        });

        if (error) {
            setErrorMsg(lang === 'ar' ? 'حدث خطأ، حاول مرة أخرى' : 'Something went wrong, please try again');
        } else {
            setSuccessMsg(lang === 'ar' ? 'تم الحجز بنجاح!' : 'Booking successful!');
            fullNameRef.current.value = '';
            emailRef.current.value = '';
            catRef.current.value = '';
            eventRef.current.value = '';
            ticketRef.current.value = '';
            setFilteredEvents([]);
        }
    };

    return (
        <section className='sec2'>
            <div className="sec2-circle sec2-circle-top"></div>
            <div className="sec2-circle sec2-circle-bottom"></div>

            <div className="sec2-container">
                <BookingHero
                    t1={lang === 'ar' ? bookingData?.section_subtitle_ar : bookingData?.section_subtitle_en}
                    t2={lang === 'ar' ? bookingData?.section_title_ar : bookingData?.section_title_en}
                    t3={''}
                    text={lang === 'ar' ? bookingData?.section_subtitle_ar : bookingData?.section_subtitle_en}
                />

                <div className="sec2-content">
                    <div className="sec2-left">
                        <p className="sec2-title">
                            {lang === 'ar' ? bookingData?.form_title_ar : bookingData?.form_title_en}
                        </p>

                        <input type="text" ref={fullNameRef} placeholder={lang === 'ar' ? 'الاسم الكامل *' : 'Full Name *'} />
                        <input type="email" ref={emailRef} placeholder={lang === 'ar' ? 'البريد الإلكتروني *' : 'Email Address *'} />

                        <div className="custom-select-wrapper">
                            <select ref={catRef} onChange={handleCategoryChange}>
                                <option value="">{lang === 'ar' ? 'اختر فئة الفعالية *' : 'Select Event Category *'}</option>
                                {categories.map(cat => (
                                    <option key={cat.id} value={cat.id}>
                                        {lang === 'ar' ? cat.name_ar : cat.name_en}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="custom-select-wrapper">
                            <select ref={eventRef} onChange={handleEventChange}>
                                <option value="">{lang === 'ar' ? 'اختر الفعالية *' : 'Select Event *'}</option>
                                {filteredEvents.map(ev => (
                                    <option key={ev.id} value={ev.id}>
                                        {lang === 'ar' ? ev.title_ar : ev.title_en}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <input type="number" min="1" ref={ticketRef} placeholder={lang === 'ar' ? 'عدد التذاكر *' : 'Number of Tickets *'} />

                        {errorMsg && <p className='err'>{errorMsg}</p>}
                        {successMsg && <p className='suc'>{successMsg}</p>}

                        <button className="sec2-btn-primary" onClick={handleBookNow}>
                            {lang === 'ar' ? bookingData?.button_text_ar : bookingData?.button_text_en}
                        </button>

                        <p className="sec2-small">{lang === 'ar' ? '* جميع الحقول مطلوبة' : '* All fields are required'}</p>
                    </div>

                    <div className="sec2-right">
                        <div className="sec2-box">
                            <p className="sec2-title">{lang === 'ar' ? 'لماذا تحجز معنا؟' : 'Why Book With Us?'}</p>
                            {benefits.map(item => (
                                <div className="sec2-item" key={item.id}>
                                    <img src={item.img} className="sec2img" alt='' />
                                    <div>
                                        <p className="sec2-text">{lang === 'ar' ? item.title_ar : item.title_en}</p>
                                        <p className="sec2-subtext">{lang === 'ar' ? item.description_ar : item.description_en}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="sec2-help">
                            <p className="sec2-title1">
                                {lang === 'ar' ? bookingData?.support_title_ar : bookingData?.support_title_en}
                            </p>
                            <p className="sec2-subtext1">{bookingData?.support_email} | {bookingData?.support_phone}</p>
                            <button className="sec2-btn-glass">
                                {lang === 'ar' ? 'تواصل مع الدعم' : 'Contact Support'}
                            </button>
                        </div>

                        <div className="sec2-strip-box">
                            <img src={strip} className="sec2-strip" alt='' />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Sec2;